import apiUsers from '@/api/all-users'

const state = {
  data: [],
  total: null,
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getAllUsersStart: '[all users] Get all users athlete start',
  getAllUsersSuccess: '[all users] Get all users athlete success',
  getAllUsersFailure: '[all users] Get all users athlete failure',
}

export const actionTypes = {
  getAllUsers: '[all users] Get all users athlete',
}

const mutations = {
  [mutationTypes.getAllUsersStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getAllUsersSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getAllUsersFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.getAllUsersStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getAllUsersSuccess](state, payload) {
    state.data = payload.data ? payload.data : payload
    state.total = payload.total ? payload.total : 0
    state.isLoading = false
  },

  [mutationTypes.getAllUsersFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getAllUsers](context, params) {
    context.commit(mutationTypes.getAllUsersStart)
    return new Promise((resolve) => {
      apiUsers
        .getAllUsersByParams(params)
        .then((response) => {
          const allUsers = response.data ? response.data : response
          context.commit(mutationTypes.getAllUsersSuccess, response)
          resolve(allUsers)
        })
        .catch(() => {
          context.commit(mutationTypes.getAllUsersFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
